var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pu_subVisual pu_sub04"},[_c('dl',[_c('dt',[_vm._v("양돈정보")]),_c('dd',[_vm._v("정부 및 대 기업체의 양돈관련 연구 프로젝트를 수행 중에 있습니다.")])])])
}]

export { render, staticRenderFns }